import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Sparkles, Sprout, ArrowRight } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function DespreMethod() {
  const pillars = [{
    number: '01',
    title: 'Conștientizare',
    icon: Eye,
    desc: 'Descoperi blocajele emoționale și credințele ascunse din subconștient care te împiedică să ai viața pe care ți-o dorești. Înveți să te observi fără judecată, să înțelegi de unde vin tiparele care se repetă și care e rădăcina reală a problemelor tale.',
    color: 'from-amber-50 to-amber-100/40'
  }, {
    number: '02',
    title: 'Transformare',
    icon: Sparkles,
    desc: 'Eliberezi credințele limitative și tiparele vechi care nu îți mai servesc. Prin meditații ghidate, tehnici practice din Theta Healing® și metoda Louise Hay, înlocuiești ceea ce te blochează cu iubire de sine, încredere și o perspectivă nouă asupra vieții.',
    color: 'from-purple-50 to-purple-100/40'
  }, {
    number: '03',
    title: 'Abundență',
    icon: Sprout,
    desc: 'Activezi starea de abundență și integrezi schimbarea în viața de zi cu zi. Înveți să atragi prosperitate, relații armonioase și pace interioară nu ca pe o teorie frumoasă, ci ca pe o practică zilnică pe care o simți și o trăiești.',
    color: 'from-sky-50 to-sky-100/40'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-1194">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1195">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1196">
          <SectionHeading title="Procesul de Transformare în 3 Pași" data-id="element-1197" />
          <p className="font-subtitle text-xl text-brand-textSec leading-relaxed -mt-4" data-id="element-1198">
            Calea prin care identifici ce te ține pe loc, eliberezi tiparele
            vechi și creezi o viață plină de abundență, echilibru și liniște
            interioară. Un proces simplu, practic, cu rezultate care se simt în
            viața reală.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 relative" data-id="element-1199">
          {/* connecting line on desktop */}
          <div aria-hidden className="hidden md:block absolute top-24 left-[16.6%] right-[16.6%] h-px bg-brand-gold/30 -z-10" data-id="element-1200" />

          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className="relative" data-id="element-1201">
                <div className={`relative bg-gradient-to-br ${pillar.color} bg-white rounded-3xl p-8 lg:p-10 h-full shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow duration-300`} data-id="element-1202">
                  {/* number circle on top */}
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-14 h-14 rounded-full bg-brand-gold flex items-center justify-center shadow-warm text-white font-heading font-bold text-lg" data-id="element-1203">
                    {pillar.number}
                  </div>

                  <div className="pt-6 text-center" data-id="element-1204">
                    <div className="w-16 h-16 mx-auto bg-white rounded-2xl flex items-center justify-center mb-6 text-brand-gold shadow-sm" data-id="element-1205">
                      <Icon className="w-8 h-8" data-id="element-1206" />
                    </div>

                    <h3 className="font-heading font-bold text-2xl text-brand-text mb-4" data-id="element-1207">
                      {pillar.title}
                    </h3>

                    <p className="text-brand-text/75 leading-relaxed" data-id="element-1208">
                      {pillar.desc}
                    </p>
                  </div>
                </div>

                {/* arrow between cards on mobile/desktop */}
                {index < pillars.length - 1 && <div aria-hidden className="hidden md:flex absolute top-1/2 -right-4 lg:-right-5 w-8 h-8 rounded-full bg-white border border-brand-gold/30 items-center justify-center text-brand-gold shadow-sm z-10 -translate-y-1/2" data-id="element-1209">
                    <ArrowRight className="w-4 h-4" data-id="element-1210" />
                  </div>}
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}